type JsonStorage = Storage & {
  serializeItem(key: string, value: any): void;
  parseItem<T = any>(key: string): T | null;
};

class JsonStorageWrapper implements JsonStorage {
  private fallback: Record<string, string> = {};

  constructor(private storage: () => Storage) {}

  get length() {
    try {
      return this.storage().length;
    } catch {
      return Object.keys(this.fallback).length;
    }
  }

  clear(): void {
    try {
      this.storage().clear();
    } catch {
      this.fallback = {};
    }
  }
  getItem(key: string): string | null {
    try {
      return this.storage().getItem(key);
    } catch {
      return this.fallback[key] ?? null;
    }
  }
  key(index: number): string | null {
    try {
      return this.storage().key(index);
    } catch {
      return Object.keys(this.fallback)[index] ?? null;
    }
  }
  removeItem(key: string): void {
    try {
      this.storage().removeItem(key);
    } catch {
      delete this.fallback[key];
    }
  }
  setItem(key: string, value: string): void {
    try {
      this.storage().setItem(key, value);
    } catch {
      this.fallback[key] = value;
    }
  }

  serializeItem(key: string, value: any): void {
    this.setItem(key, JSON.stringify(value));
  }

  parseItem<T = any>(key: string): T | null {
    const value = this.getItem(key);
    if (value == null) return null;
    return JSON.parse(value);
  }
}

export const safeLocalStorage = new JsonStorageWrapper(
  () => window.localStorage,
);
export const safeSessionStorage = new JsonStorageWrapper(
  () => window.sessionStorage,
);
